module.exports = __webpack_public_path__ + "img/logo-of-consumer-electronics-show-svg.6ff19e6e.png";